import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlags } from '../contexts/FeatureFlagContext';

/** Igual que VenueRoute, pero para el flag `venue_rewards`. */
const RewardsRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { venue_rewards, loading } = useFeatureFlags();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#181A1B',
        color: 'var(--text-primary)',
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '24px', marginBottom: '16px' }}>⚽</div>
          <div>Cargando...</div>
        </div>
      </div>
    );
  }

  if (!venue_rewards) return <Navigate to="/" replace />;
  return <>{children}</>;
};

export default RewardsRoute;
